// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qcRS","question":"styles_question__1yDtV","description":"styles_description__3TKbb"};